export enum ILocale {
  en = 'en',
  fr = 'fr',
}
